/* SPDX-License-Identifier: Apache-2.0 */
export const environment = {
  production: false,
};
